import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { getCommandResultContent, type Event } from '@/lib/traccar-api';

export function CommandResultHandler() {
  const { t } = useTranslation();
  const handledIds = useRef<Set<number>>(new Set());

  useEffect(() => {
    const handler = (e: globalThis.Event) => {
      const event = (e as CustomEvent<Event>).detail;
      console.info('[command-result] handler received event', {
        eventId: event.id,
        deviceId: event.deviceId,
        eventTime: event.eventTime,
      });
      if (handledIds.current.has(event.id)) {
        console.info('[command-result] skipped duplicate event', { eventId: event.id });
        return;
      }

      const result = getCommandResultContent(event);
      if (!result) {
        console.warn('[command-result] event has no readable result', {
          eventId: event.id,
          attributes: event.attributes,
        });
        return;
      }

      handledIds.current.add(event.id);
      console.info('[command-result] incoming result accepted', {
        eventId: event.id,
        deviceId: event.deviceId,
      });
      toast.success(t('notifications.events.commandResult'), {
        description: `#${event.deviceId}: ${result}`,
      });
    };

    window.addEventListener('traccar:commandResult', handler);
    return () => window.removeEventListener('traccar:commandResult', handler);
  }, [t]);

  return null;
}
